import { render, staticRenderFns } from "./StatisticsConfig.vue?vue&type=template&id=1f2e3ce9&scoped=true"
import script from "./StatisticsConfig.vue?vue&type=script&lang=js"
export * from "./StatisticsConfig.vue?vue&type=script&lang=js"
import style0 from "./StatisticsConfig.vue?vue&type=style&index=0&id=1f2e3ce9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2e3ce9",
  null
  
)

export default component.exports